function loadFromStorage(key, fallback) {
  if (!key) return fallback;
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Failed to load from storage for key: ${key}`);
    return fallback;
  }
}

function saveToStorage(key, value) {
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Failed to save to storage for key: ${key}`);
  }
}

function removeFromStorage(key) {
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Failed to remove from storage for key: ${key}`);
  }
}

/**
 * Remove every entry under the given key prefix whose `savedAt` timestamp is
 * older than maxAgeMs. Entries that fail to parse or lack `savedAt` count as
 * stale so corrupted values can't linger forever.
 */
function removeStaleFromStorage(prefix, maxAgeMs) {
  if (!prefix) return;
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(prefix))
      .forEach((key) => {
        let savedAt = null;
        try {
          // Coerce to a number — a corrupted non-numeric savedAt would make
          // the age comparison NaN (always false) and dodge removal forever.
          savedAt = Number(JSON.parse(localStorage.getItem(key))?.savedAt) || null;
        } catch {
          savedAt = null;
        }
        if (!savedAt || Date.now() - savedAt > maxAgeMs) {
          localStorage.removeItem(key);
        }
      });
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Failed to remove stale storage entries for prefix: ${prefix}`);
  }
}

export {
  loadFromStorage,
  removeFromStorage,
  removeStaleFromStorage,
  saveToStorage,
};
